import React from "react"
import { Grid, Typography, Box } from "@mui/material"
import CommonModal from "components/CommonModal"
import AppButton from "components/StyledComponents/AppButton"
import AppTextField from "components/StyledComponents/AppTextField"
import ToggleSwitch from "components/StyledComponents/ToggleSwitch"

const CategoryForm = ({ open, onClose, formik, isEdit = false }) => {
  return (
    <CommonModal
      open={open}
      onClose={onClose}
      title={isEdit ? "Edit Category" : "Add New Category"}
      actionButtons={
        <Box sx={{ display: "flex", justifyContent: "center", gap: 2, pb: 2 }}>
          <AppButton onClick={formik.handleSubmit} sx={{ padding: "10px 20px" }}>
            {isEdit ? "Update" : "Save"}
          </AppButton>
        </Box>
      }
      maxWidth="sm">
      <Typography variant="h2" textAlign="center">
        {isEdit ? "Edit Category" : "Add New Category"}
      </Typography>
      <Grid container spacing={2} mt={2}>
        <Grid item xs={12}>
          <AppTextField
            fullWidth
            name="name"
            label="Category Name"
            isRequired
            isUpperCase={true}
            value={formik.values.name}
            onChange={formik.handleChange}
            error={formik.touched.name && Boolean(formik.errors.name)}
            helperText={formik.touched.name && formik.errors.name}
            placeholder="Enter category name e.g. Health & Wellness"
          />
        </Grid>

        <Grid item xs={12}>
          <AppTextField
            fullWidth
            name="description"
            label="Description"
            multiline
            isUpperCase={true}
            rows={3}
            value={formik.values.description}
            onChange={formik.handleChange}
            placeholder="Enter optional description"
          />
        </Grid>

        <Grid item xs={12}>
          <Box sx={{ mt: 1, display: "flex", alignItems: "center" }}>
            <ToggleSwitch
              checked={formik.values.is_active}
              onChange={(e) => formik.setFieldValue("is_active", e.target.checked)}
            />
            <Typography variant="body2Regular" sx={{ ml: 1.5, color: "#fff" }}>
              Category is Active
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </CommonModal>
  )
}

export default CategoryForm
